function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", {
  type: "text/css"
}, "\n   \n    .fil0 {fill:#000000;fill-rule:nonzero}\n   \n  "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "fil0",
  d: "M0.261 1.537c-0.09,0 -0.173,-0.049 -0.22,-0.126 -0.053,-0.087 -0.053,-0.191 -0.009,-0.282l0.583 -0.954c0.066,-0.097 0.152,-0.175 0.277,-0.175 0.125,0 0.211,0.078 0.277,0.175l0.58 0.949c0.048,0.089 0.046,0.201 -0.007,0.287 -0.047,0.077 -0.129,0.126 -0.22,0.126l-1.261 0zm0.631 -0.498c0.053,0 0.095,0.043 0.095,0.096 0,0.053 -0.042,0.095 -0.095,0.095 -0.053,0 -0.096,-0.042 -0.096,-0.095 0,-0.053 0.043,-0.096 0.096,-0.096zm0 -0.095c-0.035,0 -0.06,-0.029 -0.064,-0.064l-0.032 -0.287c-0.005,-0.049 0.047,-0.095 0.096,-0.095 0.049,0 0.101,0.046 0.095,0.095l-0.032 0.287c-0.003,0.034 -0.027,0.064 -0.063,0.064zm-0.631 0.466l1.261 0c0.047,0 0.087,-0.026 0.112,-0.066 0.029,-0.048 0.028,-0.106 0.005,-0.156l-0.576 -0.942c-0.041,-0.06 -0.092,-0.119 -0.171,-0.119 -0.079,0 -0.131,0.059 -0.172,0.119l-0.575 0.942c-0.024,0.051 -0.025,0.108 0.005,0.156 0.024,0.04 0.064,0.066 0.111,0.066z"
}));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 1.783 1.537",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.bf3345e7.svg";
export { ForwardRef as ReactComponent };